import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { fontFamily } from '../../../../../../../constants/text';
import { colors } from '../../../../../../../constants/colors';
import NetworkStatusBadge from '../../../../../../SolvPatternLibrary/NetworkStatusBadge';
import { formatValueForDisplay } from '../../../../../../Account/Profile/Insurance/util/insuranceProgress';

const Limit = styled.div.withConfig({ componentId: 'sc-ppppcq-0' })`
  font-family: ${fontFamily.book};
  color: ${colors.purpSizzurp};
  font-size: 16px;
`;

const Checkmark = styled.img.withConfig({ componentId: 'sc-ppppcq-1' })`
  width: 40px;
  margin: 15px 0;
`;

const LimitMetStat = styled(Limit).withConfig({ componentId: 'sc-ppppcq-2' })`
  font-family: ${fontFamily.bold};
  margin-top: 4px;
`;

type Props = {
  tile: object;
  limit: number;
};

class LimitMet extends PureComponent<Props> {
  render = () => {
    const { tile, limit } = this.props;

    return (
      <>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'isInNetwork' does not exist on type 'obj... Remove this comment to see the full error message */}
        <NetworkStatusBadge isInNetwork={tile.isInNetwork} />

        <Checkmark src="/images/insurance/deductible_met_checkmark.svg" />

        <Limit>You've met your</Limit>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'subtext' does not exist on type 'object'... Remove this comment to see the full error message */}
        <LimitMetStat>{`$${formatValueForDisplay(limit)} ${tile.subtext}`}</LimitMetStat>
      </>
    );
  };
}

export default LimitMet;
